import React, { Fragment, useState } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const SelectDate = ( { inputName, initialDate = undefined, label = '' }) => {
  const [date, setDate] = useState((initialDate && new Date(initialDate)) || Date.now());

  return (
    <Fragment>

      <input name={inputName}
             value={date || Date.now()}
             hidden />

      <label>{label}</label>
      <br/>
      <DatePicker selected={date}
                  onChange={date => setDate(date)}
                  showTimeSelect
                  className="form-control" />
    </Fragment>
  );
};

export default SelectDate;
